var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame52(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_1214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.52382 6.096V3.58686L0.163574 7.11258L4.52382 10.6383V8.18661C4.52943 8.18686 4.53507 8.18698 4.54074 8.18698H11.4893C11.7054 8.18698 11.8806 8.00504 11.8806 7.78127V6.50134C11.8806 6.27727 11.7046 6.09563 11.4893 6.09563H4.54074C4.53507 6.09563 4.52943 6.09575 4.52382 6.096ZM5.8202 4.26812C6.83875 2.04027 9.02415 0.5 11.5558 0.5C15.0607 0.5 17.9021 3.45233 17.9021 7.0942C17.9021 10.7361 15.0607 13.6884 11.5558 13.6884C9.02415 13.6884 6.83875 12.1481 5.8202 9.92029H7.92899C8.75601 11.0643 10.0727 11.8043 11.5558 11.8043C14.0593 11.8043 16.0888 9.69555 16.0888 7.0942C16.0888 4.49286 14.0593 2.38406 11.5558 2.38406C10.0727 2.38406 8.75601 3.12407 7.92899 4.26812H5.8202Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame52);
export default __webpack_public_path__ + "static/media/Frame (52).0b30b07fc216c425b665264b66b47f1d.svg";
export { ForwardRef as ReactComponent };